(function () {
    'use strict';
 
    angular
        .module('app')
        .filter('translate', translate);

function translate($sce){
    return function(key) { 
    	function htmlEntities(str) {
 		   return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, "&#39;");
		}
    
        if(translations[key])
        	return $sce.trustAsHtml(translations[key]);
        else if(translations[$sce.trustAsHtml(key)])
        	return $sce.trustAsHtml( translations[ $sce.trustAsHtml(key) ] );
        else if(translations[htmlEntities(key)])
        	return $sce.trustAsHtml( translations[ htmlEntities(key) ] );


        return $sce.trustAsHtml(key);
        

    };
}
})();
